import { createSlice } from '@reduxjs/toolkit'
import {
  REDUX_STATUS_FAILED,
  REDUX_STATUS_IDLE,
  REDUX_STATUS_LOADING,
  REDUX_STATUS_SUCCESS,
} from 'src/consumer/constants'
import { getPastPatientReports } from 'src/reducers/emr/services/pastPatientReports'
import { resetStores } from 'src/store'

const initialState = {
  pastReports: {
    data: null,
    status: REDUX_STATUS_IDLE,
    apiGettingCalled: false,
    error: null,
  },
}

const emrDataSlice = createSlice({
  name: 'emrStore',
  initialState: initialState,

  reducers: {
    updateApiGettingCalledStatusForPastReports: (state, action) => {
      state.pastReports.apiGettingCalled = action.payload
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPastPatientReports.pending, (state) => {
        state.pastReports.status = REDUX_STATUS_LOADING
      })
      .addCase(getPastPatientReports.fulfilled, (state, action) => {
        state.pastReports.status = REDUX_STATUS_SUCCESS
        state.pastReports.data = action.payload
      })
      .addCase(getPastPatientReports.rejected, (state, action) => {
        state.pastReports.status = REDUX_STATUS_FAILED
        state.pastReports.error = action.payload
        // toast.error(action.payload)
      })
      .addCase(resetStores, () => initialState)
  },
})

export const { updateApiGettingCalledStatusForPastReports } = emrDataSlice.actions
export const emrDataReducer = emrDataSlice.reducer

function selectEmrDataStore(state) {
  return state.emrStore
}

export const selectEmrPastReports = (state) => {
  return selectEmrDataStore(state).pastReports
}
